import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'negativeParens', standalone: false })
export class NegativeParensPipe implements PipeTransform {
  transform(value: number): string {
    if (!value) {
      return '0';
    } else if (value < 0) {
      return '(' + value.toString().replace('-', '') + ')';
    } else {
      return value.toString();
    }
  }
}
